import type { TranslationMessages } from '../types';

export const costs: TranslationMessages = {
  title: 'Costs',
  name: 'Cost Management',
  create_cost: 'Add Cost',
  subtitle: 'Track and manage business expenses',
  versions: {
    modern: 'Modern Cost Management',
  },
  stats: {
    total_costs: 'Total Costs',
    entries: 'entries',
    this_month: 'This Month',
    current_month_expenses: 'Current Month Expenses',
    categories: 'Categories',
    active_categories: 'Active Categories',
    average_cost: 'Average Cost',
    per_entry: 'Per Entry',
  },
  search_placeholder: 'Search costs...',
  all_categories: 'All Categories',
  no_costs_found: 'No costs found',
  try_adjusting_filters: 'Try adjusting your search criteria or filters',
  add_first_cost: 'Add First Cost',
  no_permission_edit: 'You do not have permission to edit cost items.',
  fields: {
    description: 'Description',
    amount: 'Amount',
    category: 'Category',
    method: 'Payment Method',
    date: 'Date',
    notes: 'Notes',
    payment_method: 'Payment Method',
  },
  unknown: 'Unknown',
  messages: {
    costCreated: 'Cost item created successfully',
    costUpdated: 'Cost item updated successfully',
    costDeleted: 'Cost item deleted successfully',
  },
  create: {
    title: 'Create Cost Item',
    subtitle: 'Add a new expense to track',
    no_permission: 'You do not have permission to create cost items.',
    basic_information: 'Basic Information',
    description_placeholder: 'Enter cost description...',
    description_required: 'Description is required',
    amount_placeholder: '0.00',
    amount_required: 'Amount is required',
    amount_positive: 'Amount must be positive',
    date_required: 'Date is required',
    category_payment: 'Category & Payment',
    select_category: 'Select category',
    search_categories: 'Search categories...',
    no_category_found: 'No category found.',
    category_required: 'Category is required',
    payment_method_placeholder: 'Select payment method',
    payment_method_none: 'None',
    payment_method_cash: 'Cash',
    payment_method_bank: 'Bank Transfer',
    payment_method_credit_card: 'Credit Card',
    payment_method_vnpay: 'VnPay',
    payment_method_momo: 'MoMo',
    payment_method_zalopay: 'ZaloPay',
    payment_method_other: 'Other',
    receipt: 'Receipt',
    receipt_preview: 'Preview Receipt',
    upload_receipt: 'Upload Receipt',
    capture_receipt: 'Capture Receipt',
    capture_button: 'Capture',
    camera_instructions:
      'Place receipt in front of camera and click Capture when ready',
    loading_camera: 'Loading camera...',
    uploading_receipt: 'Uploading...',
    receipt_description:
      'Upload or capture receipt image (optional)',
    additional_notes: 'Additional Notes',
    notes_placeholder: 'Add any additional notes or details...',
    summary: 'Summary',
    not_selected: 'Not selected',
    save_button: 'Save Cost Item',
  },
};
